module.exports = __webpack_public_path__ + "0f603632e968328a70d9e95ed086a0a0.svg";